<div class="lm">
	<header class="lm__topbar">

		<nav class="lm__tabs" aria-label="Sections">
			<a class="lm__tab" routerLink="analysis" routerLinkActive="lm__tab--active" [routerLinkActiveOptions]="{ exact: true }">
        Analysis
      </a>

			<a class="lm__tab" routerLink="patterns" routerLinkActive="lm__tab--active">
        Patterns
      </a>

			<a class="lm__tab" routerLink="unmatched" routerLinkActive="lm__tab--active">
        Unmatched
      </a>
		</nav>
	</header>

	<main class="lm__main">
		<router-outlet></router-outlet>
	</main>
</div>
